<template>
  <main>
    <div style="background: white">
      <div class="showUs">
        <div class="content">
          <div>
            <div class="icon">
              <img src="@/assets/images/Home/start-1.png">
              <span>{{ $t('services.acquiring.icon') }}</span>
            </div>

            <div class="textContent">
              <div>
                <h3>{{ $t('services.acquiring.heroTitle') }}</h3>
                <p v-html="$t('services.acquiring.heroBody')"></p>
                <div class="action">
                  <a class="button" :href="`${this.clientUrl}/auth/register`" target="_blank">
                    <span>{{ $t('common.startNow') }}</span>
                    <div class="arrowBox">
                      <span class="arrow">
                        <i /><i /><i />
                      </span>
                    </div>

                  </a>
                  <router-link class="button" to="/customer" target="_blank">
                    <span>{{ $t('common.contactUs') }}</span>
                    <span class="arrow">
                      <i /><i /><i />
                    </span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <div class="shopInfo">
            <div>
              <img src="@/assets/images/Payment/points.png">
              <div class="itemInfo">
                <div class="menu">
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                  </svg>
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
                <div class="items">
                  <div>
                    <img src="@/assets/images/Payment/chair1.png">
                  </div>
                  <div>
                    <img src="@/assets/images/Payment/chair2.png">
                  </div>
                </div>

                <div class="desc">
                  <span>{{ $t('services.acquiring.shopTitle') }}</span>
                  <p v-html="$t('services.acquiring.shopBody')"></p>
                </div>

                <div class="flower">
                  <img src="@/assets/images/Payment/flower.png">
                </div>
              </div>
              <PhoneShopAni />
            </div>
          </div>
        </div>
      </div>

      <div class="connection content">
        <div class="textAndList">
          <span>{{ $t('services.acquiring.connectionTitle') }}</span>
          <p v-html="$t('services.acquiring.connectionBody')"></p>

          <ul>
            <li v-for="(item, index) in connectionItems" :key="item.title">
              <img :src="connectionIcons[index]" alt="Docking" />
              <span>{{ item.title }}</span>
              <p v-html="item.desc"></p>
            </li>
          </ul>
        </div>
      </div>

      <div class="optimization content">
        <div class="showFeatures">
          <div>
            <span>{{ $t('services.acquiring.optimizationTitle') }}</span>
            <p v-html="$t('services.acquiring.optimizationBody')"></p>
            <ul>
              <li v-for="(item, index) in optimizationItems" :key="index">{{ item }}</li>
            </ul>
          </div>
          <img src="@/assets/images/Payment/optimization.png">
        </div>
      </div>

      <div class="intelligent content">
        <div class="showFeatures">
          <div>
            <span>{{ $t('services.acquiring.intelligentTitle') }}</span>
            <p v-html="$t('services.acquiring.intelligentBody')"></p>
            <ul>
              <li v-for="(item, index) in intelligentItems" :key="index">{{ item }}</li>
            </ul>
          </div>
          <img src="@/assets/images/Payment/intelligent.png">
        </div>
      </div>

      <div class="process">
        <div class="content">
          <div class="textAndList">
            <span>{{ $t('services.acquiring.processTitle') }}</span>
            <p v-html="$t('services.acquiring.processBody')"></p>

            <ul>
              <li v-for="(item, index) in processItems" :key="item.title">
                <img :src="processIcons[index]">
                <span>{{ item.title }}</span>
                <p v-html="item.desc"></p>
              </li>
            </ul>
          </div>
          <div>
            <img src="@/assets/images/Payment/register1.png">
            <img src="@/assets/images/Payment/register2.png">
          </div>

        </div>
      </div>
    </div>
  </main>
</template>

<script>
  import PhoneShopAni from '@/components/PhoneShopAni';
  export default {
    name: 'Acquiring',
    components: {
      PhoneShopAni,
    },
    data() {
      return {
        stopSrc: '',
        height: window.innerHeight,
        connectionIcons: [
          require('@/assets/images/Services/docking-1.png'),
          require('@/assets/images/Services/docking-2.png'),
          require('@/assets/images/Services/docking-3.png'),
        ],
        processIcons: [
          require('@/assets/images/Services/register.png'),
          require('@/assets/images/Services/binding.png'),
          require('@/assets/images/Services/acquiring.png'),
        ],
      }
    },
    computed: {
      connectionItems() {
        return this.$t('services.acquiring.connectionItems');
      },
      optimizationItems() {
        return this.$t('services.acquiring.optimizationItems');
      },
      intelligentItems() {
        return this.$t('services.acquiring.intelligentItems');
      },
      processItems() {
        return this.$t('services.acquiring.processItems');
      },
    },
    mounted() {

    },
    destroyed() {
    }
  }
</script>

<style lang="less" scoped>
  .bodyFont(@bodyFontSize: 18px, @bodyLineHeight: 1.555555556, @fontWeightNormal: 300) {
    font: @fontWeightNormal @bodyFontSize/@bodyLineHeight "sohne-var", "Helvetica Neue", "Arial", sans-serif;
  }

  .button {
    height: auto;
    padding: 3px 0 6px;
    line-height: 1.6;
    .bodyFont(15px, 1.6, 425);
  }

  .showUs {
    background: #F6F9FC;
    padding: 112px 0 72px;
    .content {
      min-height: 577px;
      & > div {
        .icon {
          display: flex;
          align-items: center;
          height: 52px;
          & > img {
            height: 52px;
            margin-right: 20px;
          }
          & > span {
            display: flex;
            justify-content: center;
            font-size: 18px;
            font-weight: 500;
            color: #082440;
            line-height: 27px;
          }
        }
        .textContent {
          display: flex;
          & > div {
            width: 560px;
            margin-top: 72px;

            & > h3 {
              max-width: 520px;
              font-size: 48px;
              font-weight: 500;
              color: #082440;
              line-height: 58px;
            }

            & > p {
              width: 500px;
              margin-top: 30px;
              color: #082440;
              font-weight: 200;
              font-size: 20px;
              line-height: 36px;
              & > span {
                color: var(--spanColor1);
              }
            }

            .action {
              display: flex;
              margin-top: 30px;
              .button {
                width: 122px;
                margin-right: 20px;
                background: #0070FF;

                &:first-child:hover {
                  background: #0A2540;
                }

                &:last-child {
                  width: auto;
                  background: none;
                  color: #0070FF;

                  .arrow > i {
                    background: #0070FF;
                  }
                }
              }
            }
          }
        }
      }

      .shopInfo {
        position: absolute;
        top: 158px;
        right: -60px;
        transform: scale(0.9);
        transform-origin: top right;
        & > div {
          position: relative;
          height: 768px;
          & > img {
            width: 596px;
          }

          .phoneShop {
            position: absolute;
            bottom: 61px;
            left: -102px;
          }

          .itemInfo {
            position: absolute;
            top: -115px;
            left: 172px;
            padding: 0 22px;
            background: #FFFFFF;
            box-shadow: 0px 40px 80px -20px rgba(21, 21, 46, 0.32);
            border-radius: 10px;
            .menu {
              display: flex;
              height: 52px;
              border-bottom: #E0E9F0 solid 1px;
              margin-bottom: 21px;
              & > svg {
                width: 20px;
                margin-right: 40px;
              }
            }
            .items {
              display: flex;
              & > div {
                padding: 50px 38px;
                background: #EDEEEF;
                & > img {
                  height: 185px;
                }
                &:first-child {
                  margin-right: 30px;
                }
              }
            }
            .desc {
              padding: 18px 0 12px 0;
              & > span {
                font-size: 20px;
                font-weight: 400;
                color: #667583;
                line-height: 29px;
              }

              & > p {
                color: #627689;
                font-size: 16px;
                line-height: 24px;
                font-weight: 200;
                margin-top: 5px;
                & > span {
                  font-weight: 400;
                }
              }
            }

            .flower {
              display: flex;
              justify-content: center;
              padding: 36px 0 0 0;
              background: #EDEEEF;
              & > img {
                height: 105px;
              }
            }
          }
        }
      }
    }
  }

  .textAndList {
    & > span {
      font-size: 36px;
      font-weight: 400;
      color: #082440;
      line-height: 54px;
    }
    & > p {
      width: 480px;
      font-size: 20px;
      font-weight: 200;
      color: #092641;
      line-height: 36px;
      & > span {
        color: var(--spanColor1);
      }
    }

    & > ul {
      display: flex;
      padding: 0;
      margin-top: 59px;
      & > li {
        margin-right: 55px;
        & > img {
          height: 40px;
        }

        & > span {
          display: block;
          position: relative;
          font-size: 16px;
          font-weight: bold;
          color: #082440;
          line-height: 16px;
          margin-top: 20px;

          &:before {
            position: absolute;
            left: -15px;
            width: 1px;
            height: 15px;
            content: '';
            background: #0070FF;
          }
        }
        & > p {
          width: 240px;
          font-size: 16px;
          font-weight: 200;
          color: #092641;
          line-height: 24px;
          margin-top: 10px;
          & > span {
            color: var(--spanColor1);
          }
        }
      }
    }
  }
  .connection {
    padding: 120px 0 0 0;
  }

  .showFeatures {
    display: flex;
    justify-content: space-between;
    & > div {
      margin-top: 43px;
      & > span {
        font-size: 28px;
        font-weight: 400;
        color: var(--spanColor1);
        line-height: 41px;
        margin-bottom: 13px;
      }
      & > p {
        width: 480px;
        font-size: 20px;
        font-weight: 200;
        color: #092641;
        line-height: 36px;
        margin-bottom: 30px;
        & > span {
          color: var(--spanColor1);
        }
      }
      & > ul {
        list-style: none;
        & > li {
          display: flex;
          align-items: center;
          font-size: 20px;
          font-weight: 200;
          color: #092641;
          line-height: 29px;
          margin-bottom: 12px;

          &:before {
            content: '';
            display: inline-block;
            width: 8px;
            height: 8px;
            margin: 0 15px 0 10px;
            background: #0BEA82;
            box-sizing: content-box;
            border: 3px solid #BFF0E4;
            border-radius: 100%;
          }
        }
      }
    }
    & > img {
      height: 467px;
      border-radius: 16px;
      box-shadow: 0px 40px 80px -20px rgba(21, 21, 46, 0.32), 0px -3px 8px 0px rgba(149, 161, 173, 0.75) inset;
    }
  }
  .optimization {
    padding: 130px 0 0 0;
  }

  .intelligent {
    padding: 95px 0 180px 0;
    .showFeatures > img {
      height: 418px;
    }
  }

  .process {
    padding: 142px 0 0 0;
    background: #F6F9FC;
    overflow: hidden;
    .content {
      display: flex;
      justify-content: space-between;
      & > div {
        position: relative;
        right: 0;
        bottom: -20px;
        & > img {
          width: 296px;
          border-radius: 12px;
          box-shadow: 0px 40px 80px -20px rgba(21, 21, 46, 0.32), 0px -3px 8px 0px rgba(149, 161, 173, 0.75) inset;
          &:last-child {
            position: absolute;
            top: 57px;
            left: 47px;
          }
        }
      }
    }
  }

@media screen and (max-width: 1000px) {
  .showUs {
    padding: 72px 0 40px;

    .content {
      min-height: auto;
      padding: 0 20px;
      display: flex;
      flex-direction: column;
    }

    .content > div .textContent > div {
      width: auto;
      margin-top: 24px;

      & > h3 {
        max-width: none;
        font-size: 32px;
        line-height: 44px;
      }

      & > p {
        width: auto;
        max-width: none;
        font-size: 18px;
        line-height: 30px;
      }
    }

    .shopInfo {
      position: relative;
      top: 0;
      right: 0;
      transform: none;
      margin-top: 24px;

      & > div {
        height: auto;

        & > img {
          width: 100%;
          max-width: 596px;
        }

        .phoneShop {
          left: -40px;
          bottom: 20px;
          transform: scale(0.86);
          transform-origin: left bottom;
        }

        .itemInfo {
          left: auto;
          right: 20px;
          top: -48px;
          transform: scale(0.88);
          transform-origin: top right;
        }
      }
    }
  }

  .connection,
  .optimization,
  .intelligent,
  .process {
    padding-left: 20px;
    padding-right: 20px;
  }

  .textAndList {
    & > span,
    & > h3 {
      font-size: 30px;
      line-height: 40px;
    }

    & > p {
      width: 100%;
      max-width: 560px;
      font-size: 18px;
      line-height: 30px;
    }

    & > ul {
      flex-wrap: wrap;
      gap: 24px 0;

      & > li {
        width: 50%;
        margin-right: 0;
        padding-right: 24px;

        & > p {
          width: auto;
        }
      }
    }
  }

  .showFeatures {
    align-items: center;
    gap: 32px;

    & > div {
      flex: 1;

      & > p {
        width: auto;
      }
    }

    & > img {
      width: 44%;
      height: auto;
      max-width: 467px;
    }
  }

  .process {
    .content {
      gap: 32px;
      align-items: flex-start;

      & > div:last-child {
        min-width: 260px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .showUs {
    padding: 40px 16px 20px;
    overflow: hidden;

    .content {
      min-height: auto;
      padding: 0;

      & > div:first-child {
        width: 100%;
        min-width: 0;

        .icon {
          height: auto;
          justify-content: center;
          margin-bottom: 0;

          & > img {
            height: 32px;
            margin-right: 8px;
          }

          & > span {
            font-size: 14px;
            line-height: 20px;
          }
        }

        .textContent {
          display: block;
          width: 100%;

          & > div {
            width: 100%;
            margin-top: 24px;

            & > h3 {
              max-width: none;
              margin-bottom: 10px;
              font-size: 24px;
              line-height: 1.25;
              text-align: center;
            }

            & > p {
              width: auto;
              max-width: none;
              margin-top: 0;
              margin-bottom: 20px;
              font-size: 15px;
              line-height: 1.6;
              text-align: left;
            }

            .action {
              flex-direction: column;
              align-items: center;
              gap: 12px;
              margin-top: 0;

              .button {
                width: 100%;
                max-width: 320px;
                margin: 0;

                &:last-child {
                  width: 100%;
                  max-width: 320px;
                }
              }
            }
          }
        }
      }
    }

    .shopInfo {
      display: none;
    }
  }

  .connection,
  .optimization,
  .intelligent,
  .process {
    padding-left: 16px;
    padding-right: 16px;
  }

  .connection {
    padding-top: 72px;
  }

  .optimization {
    padding-top: 72px;
  }

  .intelligent {
    padding: 72px 16px 96px;
  }

  .textAndList {
    & > span,
    & > h3 {
      font-size: 26px;
      line-height: 34px;
    }

    & > p {
      font-size: 16px;
      line-height: 28px;
    }

    & > ul {
      margin-top: 32px;
      gap: 20px;

      & > li {
        width: 100%;
        padding-right: 0;

        & > span {
          margin-top: 16px;
        }
      }
    }
  }

  .showFeatures {
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;

    & > div {
      margin-top: 0;

      & > span {
        font-size: 24px;
        line-height: 32px;
      }

      & > p {
        font-size: 16px;
        line-height: 28px;
      }

      & > ul > li {
        align-items: flex-start;
        font-size: 16px;
        line-height: 24px;
      }
    }

    & > img {
      width: 100%;
      max-width: none;
    }
  }

  .process {
    padding-top: 88px;

    .content {
      flex-direction: column;
      gap: 24px;

      & > div:last-child {
        width: 100%;
        min-width: 0;
        padding-bottom: 180px;

          & > img {
            width: 72vw;
            max-width: 296px;

            &:last-child {
            left: auto;
            right: 0;
            top: 42px;
          }
        }
      }
    }
  }
}
</style>
